<template>
    <div class="lotti-footer">
      <span>© Copyright {{ new Date().getFullYear() }} - Atticode GmbH</span>
      <span>
        <router-link :to="{ name: 'terms' }">
          Nutzungsbedingungen
        </router-link>
      </span>
      <span>
        <router-link :to="{ name: 'privacy' }">
          Datenschutzrichtline
        </router-link>
      </span>
    </div>
</template>

<script>
    export default {
        data() {
          return {

          }
        }
    }
</script>